var module = angular.module('octopusApp.projects');

module.directive('actionTemplateField', function($compile, $templateCache, octoUtil) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        require: 'ngModel',
        scope: {
            parameter: '=',
            placeholder: '=',
            selectOptions: '=',
            project: '=',
            tenantId: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: function(){},
        link: function($scope, $element, attr, ngModel) {
            var vm = $scope.vm;

            ngModel.$render = function onRender() { // Update internal selected if outer model changes
                $scope.vm.value = ngModel.$viewValue;
            };
            $scope.$watch(function(){return $scope.vm.value;}, function(){
                ngModel.$setViewValue($scope.vm.value);
            });

            $scope.$watch(function(){ return vm.parameter;}, function() {
                if (!vm.parameter) {
                    return;
                }
                var template = getFieldTemplate(vm.parameter);
                $element.html('');
                $element.html($compile(template)($scope));
            });

            var selectOptions = null;

            vm.getSelectOptions = function getSelectOptions(){
                if(selectOptions) {
                    return selectOptions;
                }

                if(vm.parameter && vm.parameter.DisplaySettings['Octopus.SelectOptions']) {
                    selectOptions = octoUtil.selectOptionsTextToList(vm.parameter.DisplaySettings['Octopus.SelectOptions']);
                    return selectOptions;
                }

                if(!vm.selectOptions || !vm.parameter) {
                    return null;
                }

                selectOptions = vm.selectOptions[vm.parameter.DisplaySettings["Octopus.ControlType"]];
                return selectOptions;
            };

             vm.certificateSelected = function(certificateId) {
               $scope.vm.value = certificateId;
             };

             vm.isAzureAccount = function(account) {
                return account.AccountType === 'AzureSubscription' || account.AccountType === 'AzureServicePrincipal';
             };
        }
    };

    function getFieldTemplate(parameter) {
        var controlType;
        if (parameter.DisplaySettings) {
            controlType = parameter.DisplaySettings["Octopus.ControlType"];
            if (!controlType) {
                controlType = "SingleLineText";
            }
        }

        return $templateCache.get('areas/projects/action-template-fields/field-' + controlType + '.html');
    }
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/action_template_field.js
// module id = 744425539255213
// module chunks = 1